import Search from "ui/search";
import SiteItem from "./site-item";
export default function SiteList({
  sites,
  onSelectSite,
  currentSite,
  orgId,
  onCameraClick,
  locations,
  currentCamera,
  withCapabilities = "",
  hideOffline = false,
}) {
  return (
    <div className="w-full">
      <div className="mb-3">
        <Search placeholder="Search site name..." />
      </div>
      {!sites.length && <div>Loading sites</div>}
      {sites.map((data: any) => {
        return (
          <SiteItem
            withCapabilities={withCapabilities}
            currentCamera={currentCamera}
            locations={locations}
            orgId={orgId}
            onCameraClick={onCameraClick}
            key={data.id}
            site={data}
            onlineCamNum={data.stats?.onlineCamNum || 0}
            offlineCamNum={data.stats?.offlineCamNum || 0}
            onActive={onSelectSite}
            currentSite={currentSite}
            hideOffline={hideOffline}
          />
        );
      })}
    </div>
  );
}
